export default __webpack_public_path__ + "static/media/pizzaHomeImg.1827e889.jpg";